import toggleArchiveTabs from './archive-tab-navigation'

export default function archiveTabs () {
  toggleArchiveTabs()
}
